import React, { useMemo, useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Card,
  Typography,
  Radio,
  message,
  Empty,
  Row,
  Col,
  Space,
} from "antd";
import { PlusOutlined, CheckOutlined } from "@ant-design/icons";

const { Title } = Typography;

const CadastroProdutoModal = ({
  produtos = [],
  categorias = [],
  setCategorias,
  setProdutos,                 // atualiza a lista imutavelmente
  setIsFinalizarEntrada,       // fecha a etapa de cadastro
  salvarEntrada,               // continuar o fluxo após tratar todos
  onCriarCategoria,            // <<< NOVO: função async para POST de categoria (nome) => {id, nome}
}) => {
  const [idx, setIdx] = useState(0);

  const [modoCriarCategoria, setModoCriarCategoria] = useState(false);
  const [novaCategoria, setNovaCategoria] = useState("");
  const [categoriaCriada, setCategoriaCriada] = useState(false);
  const [tipoValor, setTipoValor] = useState("preco"); // 'preco' | 'margem'
  const [tipoValorTodos, setTipoValorTodos] = useState(''); // 'preco' | 'margem'
  const [valor, setValor] = useState(null);            // string com vírgula (máscara reversa)
  const [custo, setCusto] = useState("");
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(undefined);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [criandoCategoria, setCriandoCategoria] = useState(false);
  const [criada, setCriada] = useState('');




  const produtoAtual = useMemo(() => {
    if (!produtos.length) return { cProd: "", nome: "Sem produtos", custo: 0, preco: null };
    return produtos[idx] || { cProd: "", nome: "Produto (visual)", custo: 0, preco: null };
  }, [produtos, idx]);

  const formatBR = (v) => {
    if (v == null) return "";
    const s = String(v);
    return s.replace(/\./g, ",");
  };


  const getCategoriaIdFromProduto = (p) => {
    if (!p) return undefined;
    const cat = p.categoria;
    if (!cat) return undefined;
    if (typeof cat === "object" && cat !== null && "id" in cat) return String(cat.id);
    return String(cat);
  };

  // Sincroniza campos quando muda o produto atual
  useEffect(() => {
    setCusto(formatBR(produtoAtual?.custo ?? ""));
    // Preenche o campo visual de preço com o preço do produto (formatado)
    const precoNumber =
      produtoAtual?.preco != null && produtoAtual.preco !== ""
        ? Number(produtoAtual.preco)
        : null;

    if (!categoriaCriada) {
      console.log('alterando valor');
      setValor(
        precoNumber == null
          ? ""
          : precoNumber.toFixed(2).replace(".", ",")
      );
    }

    const pid = getCategoriaIdFromProduto(produtoAtual);
    if (pid && categorias?.length) {
      const match = categorias.find((c) => String(c.id) === String(pid));
      setCategoriaSelecionada(match ? String(match.id) : undefined);
    } else {
      setCategoriaSelecionada(undefined);
    }

    setModoCriarCategoria(false);
    setNovaCategoria("");
    setCategoriaCriada(false);
  }, [produtoAtual, categorias]);

  // Criação de categoria (POST se onCriarCategoria existir)
  const adicionarCategoria = async () => {
    const nome = (novaCategoria || "").trim();

    // Se vazio, apenas volta para SELECT (sem cadastrar)
    if (!nome) {
      setModoCriarCategoria(false);
      setNovaCategoria("");
      return;
    }

    try {
      setCriandoCategoria(true);

      let criada = null;


      // chama o endpoint externo
      console.log(nome);
      criada = await onCriarCategoria(nome);

      if (criada) {
        setCategoriaCriada(true);
        setCategorias?.([...(categorias || []), criada]);
        message.success(`Categoria "${criada.nome}" adicionada com sucesso!`);
        setNovaCategoria("");
        setModoCriarCategoria(false);
        setTimeout(() => {
          setCategoriaSelecionada(String(criada.id));
        }, 1000);
      }

    } catch (err) {
      console.error(err);
      message.error("Não foi possível criar a categoria.");
    } finally {
      setCriandoCategoria(false);
    }
  };

  // Salva o produto atual (atualiza por cProd)
  const toNumber = (v) => {
    if (v == null || v === "") return null;
    if (typeof v === "number") return v;
    const n = Number(String(v).replace(/\./g, "").replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };

  // Salva o produto atual (respeita "preco" ou "margem")
  const salvarProdutoAtual = () => {
    if (!Array.isArray(produtos) || !produtos.length) return produtos;

    const catId = categoriaSelecionada ?? getCategoriaIdFromProduto(produtoAtual);

    let precoNumber = null;
    if (tipoValor === "margem") {
      const margemPct = toNumber(valor) ?? 0;            // ex.: "10,00" -> 10
      const custoNum = toNumber(produtoAtual?.custo) ?? 0;
      precoNumber = Number((custoNum * (1 + margemPct / 100)).toFixed(2));
    } else {
      precoNumber = toNumber(valor);                     // preço direto
    }

    const atualizado = {
      ...produtoAtual,
      preco: precoNumber,
      categoria: catId,
      tipoValor,                                        // preserva como foi definido
      ...(tipoValor === "margem" ? { margem: toNumber(valor) ?? 0 } : { margem: undefined }),
    };

    const next = produtos.map((p) =>
      String(p.cProd) === String(atualizado.cProd) ? atualizado : p
    );

    if (typeof setProdutos === "function") setProdutos(next);

    console.log("✅ Produto salvo:", atualizado);
    return next;
  };

  // Finaliza etapa e chama salvarEntrada
  const finalizarFluxo = async (produtosFinais) => {
    try {
      setIsSubmitting(true);
      setIsFinalizarEntrada(false);
      salvarEntrada(produtosFinais);
    } catch (e) {
      console.error(e);
      message.error("Falha ao continuar o fluxo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Aplica os valores do atual para ele + TODOS os próximos
  // Se o atual estiver em "margem", recalcula o preço de CADA próximo pelo próprio custo.
  const aplicarParaProximos = () => {
    if (!Array.isArray(produtos) || !produtos.length || isSubmitting) return;

    // 1) Gera array já com o produto atual salvo
    const base = salvarProdutoAtual();

    // 2) Coleta os parâmetros do produto-base
    const catIdBase = categoriaSelecionada ?? getCategoriaIdFromProduto(produtoAtual);
    const precoBase = toNumber(valor);
    const margemBase = toNumber(valor); // quando tipoValor === "margem", isso é o % digitado

    // 3) Cria o novo array aplicando aos próximos
    const next = base.map((p, i) => {
      if (i < idx) return p;

      const novo = { ...p, categoria: catIdBase };

      if (tipoValor === "margem") {
        const custoNum = toNumber(p?.custo);
        if (custoNum != null) {
          novo.preco = Number((custoNum * (1 + (margemBase ?? 0) / 100)).toFixed(2));
        } else {
          novo.preco = null; // ou 0, se preferir
        }
        novo.tipoValor = "margem";
        novo.margem = margemBase ?? 0;
      } else {
        novo.preco = precoBase;
        novo.tipoValor = "preco";
        delete novo.margem;
      }

      return novo;
    });

    // 4) Atualiza state e finaliza fluxo
    if (typeof setProdutos === "function") setProdutos(next);

    message.success(
      tipoValor === "margem"
        ? "Margem aplicada ao atual e recalculada para todos os próximos."
        : "Preço aplicado ao atual e copiado para todos os próximos."
    );

    finalizarFluxo(next);
  };

  const irParaProximo = async () => {
    if (!produtos.length || isSubmitting) return;

    const nextProdutos = salvarProdutoAtual();

    if (idx >= nextProdutos.length - 1) {
      await finalizarFluxo(nextProdutos);
      return;
    }

    setIdx((i) => i + 1);
  };

  return (
    <Card style={{ maxWidth: 640, margin: "20px auto" }}>
      <Title level={4} style={{ textAlign: "center", marginBottom: 8 }}>
        Cadastrando Produtos / Itens
      </Title>

      {/* Cabeçalho com referência do produto + posição */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          alignItems: "baseline",
          marginBottom: 8,
        }}
      >
        <div
          style={{
            fontWeight: 600,
            fontSize: 14,
            color: "#333",
            wordBreak: "break-word",
            flex: 1,
          }}
        >
          {produtoAtual?.cProd ? `${produtoAtual.cProd} — ` : ""}
          {produtoAtual?.nome || ""}
        </div>
        <div style={{ fontSize: 12, color: "#666", minWidth: 90, textAlign: "right" }}>
          {produtos.length ? `Item ${idx + 1} de ${produtos.length}` : "—"}
        </div>
      </div>

      <Form layout="vertical">
        <Form.Item label="Tipo de cálculo">
          <Radio.Group
            value={tipoValor}
            onChange={(e) => { setTipoValor(e.target.value); console.log(tipoValor); }}
          >
            <Radio value="preco">Preço (R$)</Radio>
            <Radio value="margem">Margem (%)</Radio>
          </Radio.Group>
        </Form.Item>

        {/* Preço/Margem e Custo lado a lado */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={tipoValor === "preco" ? "Preço" : "Margem"}>
              <Input
                value={valor}
                onChange={(e) => {
                  let v = e.target.value.replace(/\D/g, ""); // só números
                  if (!v) {
                    setValor("");
                    return;
                  }
                  v = (parseInt(v, 10) / 100).toFixed(2).replace(".", ",");
                  setValor(v);
                }}
                placeholder="0,00"
                style={{ textAlign: "right" }}
                prefix={tipoValor === "preco" ? "R$" : ""}
                suffix={tipoValor === "margem" ? "%" : ""}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Custo">
              <Input value={`R$ ${custo}`} readOnly />
            </Form.Item>
          </Col>
        </Row>

        {/* Categoria */}
        <Form.Item label="Categoria">
          <Space.Compact style={{ width: "100%" }}>
            {modoCriarCategoria ? (
              <Input
                placeholder="Digite o nome da categoria"
                value={novaCategoria}
                onChange={(e) => setNovaCategoria(e.target.value)}
                disabled={criandoCategoria || isSubmitting}
              />
            ) : (
              <Select
                placeholder="Selecione"
                value={categoriaSelecionada}
                onChange={setCategoriaSelecionada}
                options={(categorias || []).map((c) => ({
                  value: String(c.id),
                  label: c.nome,
                }))}
                notFoundContent={
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Sem categorias"
                  />
                }
                disabled={criandoCategoria || isSubmitting}
              />
            )}

            <Button
              style={{
                backgroundColor: "#000",
                borderColor: "#000",
                color: "#fff",
              }}
              icon={modoCriarCategoria ? <CheckOutlined /> : <PlusOutlined />}
              onClick={() => {
                if (modoCriarCategoria) {
                  adicionarCategoria(); // chama POST se onCriarCategoria existir
                } else {
                  setModoCriarCategoria(true);
                }
              }}
              loading={criandoCategoria}
              disabled={isSubmitting}
            />
          </Space.Compact>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            block
            style={{ backgroundColor: "#000", borderColor: "#000", color: "#fff" }}
            onClick={irParaProximo}
            disabled={!produtos.length || isSubmitting}
          >
            Próximo →
          </Button>
        </Form.Item>

        <Form.Item>
          <Button
            block
            style={{ backgroundColor: "#000", borderColor: "#000", color: "#fff" }}
            onClick={aplicarParaProximos}
            disabled={!produtos.length || isSubmitting}
          >
            Aplicar estes valores para todos os próximos
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CadastroProdutoModal;
